export default __webpack_public_path__ + "static/media/student_mission_2.e77a1bf2.png";